import { render } from "./table_menu.vue?vue&type=template&id=8dd0b7d0&lang=pug"
import script from "./table_menu.vue?vue&type=script&lang=js"
export * from "./table_menu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__